import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Chip, Divider, Grid, Typography, useMediaQuery } from "@mui/material";
import { t } from "i18next";
import { WarningTriangle } from "../../../../assets/images";
import { MuiButton, MuiPopup, MuiStack } from "../../../../components";
import { ALTERNATE_PART_RELATIONSHIP_LABEL_MAP } from "../../../../constants";
import { systemColor } from "../../../../theme/systemColor";
var AlternatePartPopup = function (_ref) {
    var alterNatePartDetails = _ref.alterNatePartDetails, setAlterNatePartDetails = _ref.setAlterNatePartDetails, searchedPart = _ref.searchedPart, setSearchedPart = _ref.setSearchedPart, replacePart = _ref.replacePart, alternetPartPopupOpen = _ref.alternetPartPopupOpen, setAlternetPartPopupOpen = _ref.setAlternetPartPopupOpen;
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var alterNatePartAssociation = alterNatePartDetails && alterNatePartDetails[0] && alterNatePartDetails[0].AssociationName ? alterNatePartDetails[0].AssociationName : "";
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: alternetPartPopupOpen,
        closeIcon: true,
        onClose: function () {
            setAlternetPartPopupOpen(false);
        },
        backdropEnable: true,
        containerStyle: {
            width: IS_MOBILE ? "100%" : '450px',
            height: "625px"
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement("img", {
        src: WarningTriangle
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1",
        fontWeight: "bold"
    }, ALTERNATE_PART_RELATIONSHIP_LABEL_MAP[alterNatePartAssociation]), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "textSecondary"
    }, "".concat(alterNatePartDetails && (alterNatePartDetails === null || alterNatePartDetails === void 0 ? void 0 : alterNatePartDetails.length), " alternate ").concat((alterNatePartDetails === null || alterNatePartDetails === void 0 ? void 0 : alterNatePartDetails.length) > 1 ? "parts" : "part", " available for the part selected."))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        bgcolor: '#F4F7FA',
        padding: 1,
        border: 1,
        borderRadius: 2,
        borderColor: "grey.300"
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 1.4
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        onClick: function () {
            var cloned = _objectSpread(_objectSpread({}, searchedPart), {}, {
                isChecked: true
            });
            setSearchedPart(cloned);
            setAlterNatePartDetails(alterNatePartDetails === null || alterNatePartDetails === void 0 ? void 0 : alterNatePartDetails.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                    isChecked: false
                });
            }));
        },
        alignItems: 'center',
        justifyContent: 'center',
        sx: {
            height: 16,
            width: 16,
            borderRadius: "50%",
            border: "1px solid ".concat(systemColor.grey),
            bgcolor: searchedPart && searchedPart.isChecked ? systemColor.primary : systemColor.white
        }
    }, searchedPart && searchedPart.isChecked && /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            height: 9,
            width: 9,
            borderRadius: "50%",
            border: "1px solid ".concat(systemColor.primary),
            bgcolor: systemColor.white
        }
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4,
        spacing: 1,
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        component: "div"
    }, searchedPart && searchedPart.Name ? searchedPart.Name : "-"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: "textSecondary"
    }, searchedPart && searchedPart.SkuCode ? '#' + searchedPart.SkuCode : "-"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        component: "div"
    }, "Available qty :"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: "textSecondary"
    }, searchedPart && typeof searchedPart.Quantity === 'number' ? searchedPart.Quantity : "-")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 2,
        container: true,
        justifyContent: "flex-start"
    }, /*#__PURE__*/ React.createElement(Chip, {
        label: 'P',
        size: "small",
        sx: {
            ml: 1,
            color: systemColor.primary,
            border: '1px solid #AFD5FF',
            bgcolor: "#EEF6FF"
        }
    })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1",
        fontWeight: "bold"
    }, "Alternate Parts")), alterNatePartDetails === null || alterNatePartDetails === void 0 ? void 0 : alterNatePartDetails.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            padding: 1,
            key: index
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            spacing: 1
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 1.4
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            onClick: function () {
                setSearchedPart(_objectSpread(_objectSpread({}, searchedPart), {}, {
                    isChecked: false
                }));
                setAlterNatePartDetails(alterNatePartDetails.map(function (item, itemIndex) {
                    return _objectSpread(_objectSpread({}, item), {}, {
                        isChecked: index === itemIndex ? true : false
                    });
                }));
            },
            alignItems: 'center',
            justifyContent: 'center',
            sx: {
                height: 16,
                width: 16,
                borderRadius: "50%",
                border: "1px solid ".concat(systemColor.grey),
                bgcolor: item.isChecked ? systemColor.primary : systemColor.white
            }
        }, item.isChecked && /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                height: 9,
                width: 9,
                borderRadius: "50%",
                border: "1px solid ".concat(systemColor.primary),
                bgcolor: systemColor.white
            }
        })), /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            color: "textSecondary"
        })), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 4,
            spacing: 1,
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            component: "div"
        }, item && item.PartName ? item.PartName : "-"), /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: "textSecondary"
        }, item && item.PartCode ? item.PartCode : "-"), /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            component: "div"
        }, "Available qty :"), /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: "textSecondary"
        }, item && typeof Number(item.MinQuantity) === 'number' ? item.MinQuantity : "-")), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 2,
            container: true,
            justifyContent: "flex-start"
        }, /*#__PURE__*/ React.createElement(Chip, {
            label: 'P',
            size: "small",
            sx: {
                ml: 1,
                color: systemColor.primary,
                border: '1px solid #AFD5FF',
                bgcolor: "#EEF6FF"
            }
        })))), /*#__PURE__*/ React.createElement(Divider, {
            style: {
                width: "100%"
            }
        }));
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        padding: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "removeButton",
        name: t('Cancel'),
        variant: "outlined",
        style: {
            fontSize: "16px",
            fontWeight: "500",
            marginTop: "10px",
            padding: "20px",
            width: '95%',
            alignSelf: 'center'
            //opacity: !selectedAdvisor ? 0.5 : 1,
        },
        onClick: function () {
            setAlternetPartPopupOpen(false);
        },
        disabled: false
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        component: "div"
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "saveButton",
        name: t('Replace'),
        variant: "contained",
        style: {
            fontSize: "16px",
            fontWeight: "500",
            marginTop: "10px",
            padding: "20px",
            width: '95%',
            alignSelf: 'center'
            //opacity: !selectedAdvisor ? 0.5 : 1,
        },
        onClick: replacePart,
        disabled: false
    })))))));
};
export default AlternatePartPopup;
